import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "/course-annual";

export class CourseAnnualApi extends BaseAPI {
  static list(query: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patch(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static closeClass(id: any, body:any): Promise<any> {
    return this.api.patch(`${path}/${id}/close-class`, body);
  }
  static getFile(id: any): Promise<any> {
    return this.api.get(`${path}/file/${id}`, {
      responseType: "arraybuffer",
    });
  }
  static publish(body: any): Promise<any> {
    return this.api.patch(`${path}/update_publish`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static listDropdownByCourse(id_courses: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/list-employee-by-course`, {
      params: {
        id_courses
      }
    })
  }
}
